export default __webpack_public_path__ + "static/run-96b00fdd6c3448d7441fadde8c43657c.gif";